import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

// Eager metadata registration; the render component (CircularPercentage)
// code-splits into its own tpl-circular-percentage chunk, loaded on demand.
registerCardTemplate({
    id: 'circular-percentage',
    name: "CircularPercentage card",
    description: 'A widget to show Percentage',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-circular-percentage" */ "./CircularPercentage")),
    icon: generateIconProp('tachometerAlt'),
    complexity: 'medium',
});
